import * as dom from './wpstg-dom-utils.js';

/**
 * Handle toggle of advance settings checkboxes
 */
export default class WpstgCloningAdvanceSettings {
  constructor(
      baseContainerSelector = '#wpstg-clonepage-wrapper',
  ) {
    this.baseContainer = dom.qs(baseContainerSelector);
    this.checkBoxSettingTogglerSelector = '.wpstg-toggle-advance-settings-section';
    this.init();
  }

  /**
   * Add events
   * @return {void}
   */
  addEvents() {
    if (this.baseContainer === null) {
      return;
    }

    dom.addEvent(this.baseContainer, 'change', this.checkBoxSettingTogglerSelector, (element) => {
      this.toggleSettings(element);
    });
  }

  /**
   * @return {void}
   */
  init() {
    this.addEvents();
  }

  /**
   * Expand/Collapse checkbox content on change
   * @return {void}
   */
  toggleSettings(element) {
    const target = dom.qs('#' + element.getAttribute('data-id'));
    if (element.checked) {
      dom.slideDown(target);
    } else {
      dom.slideUp(target);
    }
  }
}
